import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/header.jpg'


const _hoisted_1 = {
  id: "nav",
  class: "navbar navbar-expand-lg fixed-top p-0"
}
const _hoisted_2 = { class: "container header" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}
const _hoisted_5 = { class: "navbar-toggler-icon" }
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_7 = { class: "navbar-nav mr-auto" }
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = ["href", "onClick"]
const _hoisted_12 = { class: "navbar-text pl-3" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_15 = { href: "https://www.facebook.com/English-Mastiff-FCI-Komorowianka-517689788743992/" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "container p-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "LOGO",
    style: {"max-width":"100%"}
  })
], -1)
const _hoisted_17 = { class: "container bg-dark-section py-4 px-5" }
const _hoisted_18 = { class: "row mb-3" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-3 text-center text-md-left brand\"> Komorowianka </div><div class=\"col-6 col-md-3\">05-085 Kampinos</div><div class=\"col-6 col-md-3\"><a class=\"email_small\" href=\"mailto:fci.komorowianka@wp.pl\">fci.komorowianka@wp.pl</a><br><a href=\"tel:+48 664 470 660\">+48 664 470 660</a></div>", 3)
const _hoisted_22 = { class: "col-12 col-md-3 text-center text-md-right" }
const _hoisted_23 = { href: "https://www.facebook.com/English-Mastiff-FCI-Komorowianka-517689788743992/" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Copyright © 2021 Komorowianka")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: "navbar-brand",
          href: `/${_ctx.i18nConst.getLocale()}`
        }, "Komorowianka", 8, _hoisted_3),
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, { icon: "bars" })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: `/${_ctx.i18nConst.getLocale()}`,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("li", {
                  class: _normalizeClass([
                isActive && 'active',
                isExactActive && 'active-exact',
                'nav-item',
              ])
                }, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: href,
                    onClick: navigate
                  }, _toDisplayString(_ctx.translate('message.home.title')), 9, _hoisted_8)
                ], 2)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/${_ctx.i18nConst.getLocale()}/gallery`,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("li", {
                  class: _normalizeClass([
                isActive && 'active',
                isExactActive && 'active-exact',
                'nav-item',
              ])
                }, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: href,
                    onClick: navigate
                  }, _toDisplayString(_ctx.translate('message.gallery.title')), 9, _hoisted_9)
                ], 2)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/${_ctx.i18nConst.getLocale()}/puppies`,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("li", {
                  class: _normalizeClass([
                isActive && 'active',
                isExactActive && 'active-exact',
                'nav-item',
              ])
                }, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: href,
                    onClick: navigate
                  }, _toDisplayString(_ctx.translate('message.puppies.title')), 9, _hoisted_10)
                ], 2)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/${_ctx.i18nConst.getLocale()}/contact`,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("li", {
                  class: _normalizeClass([
                isActive && 'active',
                isExactActive && 'active-exact',
                'nav-item',
              ])
                }, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: href,
                    onClick: navigate
                  }, _toDisplayString(_ctx.translate('message.contact.title')), 9, _hoisted_11)
                ], 2)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: "/pl",
              class: "flag-pl"
            }),
            _hoisted_13,
            _createVNode(_component_router_link, {
              to: "/en",
              class: "flag-gb"
            }),
            _hoisted_14,
            _createElementVNode("a", _hoisted_15, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fab', 'facebook-square'],
                size: "lg"
              })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_16,
    _createVNode(_component_router_view),
    _createElementVNode("footer", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("a", _hoisted_23, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fab', 'facebook-square'],
              size: "2x"
            })
          ])
        ])
      ]),
      _hoisted_24,
      _hoisted_25
    ])
  ], 64))
}